import CryptoJS from "crypto-js";
import md5 from "md5";
import { CryptoInitializationError, INCORRECT_MASTER_KEY } from "./cryptoErrors";

const SECRET_KEY = process.env.REACT_APP_BENCHMARKING_KEY;
const SIA_ID_STORAGE_KEY = "sia.benchmarking.siaId";
const hasText = (value) => value !== null && value !== undefined && String(value).length > 0;

export class CryptoEngineV1 {
  static VERSION = "v1";

  constructor(masterKey) {
    if (!masterKey) throw new CryptoInitializationError("CryptoEngineV1: missing master key");
    this.version = CryptoEngineV1.VERSION;
    this.masterKey = masterKey;
    this.siaId = sessionStorage.getItem(SIA_ID_STORAGE_KEY);
    this.key = CryptoJS.enc.Hex.parse(CryptoJS.SHA256(masterKey).toString());
    this.validationHash = md5(masterKey);
    this.companyHash = this.encryptMessage(`${this.siaId}${SECRET_KEY}`);
  }

  ready() {
    if (!this.masterKey || !this.key) throw new CryptoInitializationError("CryptoEngineV1: engine is unavailable");
    return Promise.resolve(this);
  }

  getValidationHash() {
    return this.validationHash;
  }

  getCompanyHash() {
    return this.companyHash;
  }

  async encryptEmployee(nameOrNum) {
    await this.ready();
    const value = String(nameOrNum ?? "").trim();
    if (!value) throw new Error("CryptoEngineV1: missing employee name/number");
    return this.encryptMessage(`${this.siaId}${value}*-${Date.now()}-`);
  }

  async decryptEmployee(cipherText) {
    if (!cipherText || !this.key) return INCORRECT_MASTER_KEY;
    try {
      const bytes = CryptoJS.enc.Hex.parse(cipherText).toString(CryptoJS.enc.Base64);
      const decrypted = CryptoJS.AES.decrypt(bytes, this.key, { mode: CryptoJS.mode.ECB }).toString(CryptoJS.enc.Utf8);
      const value = decrypted.replace(this.siaId, "").split("*")[0];
      return hasText(value) ? value : INCORRECT_MASTER_KEY;
    } catch (error) {
      return INCORRECT_MASTER_KEY;
    }
  }

  purge() {
    this.masterKey = null;
    this.key = null;
    this.validationHash = null;
    this.companyHash = null;
  }

  encryptMessage(message) {
    if (!this.key) throw new CryptoInitializationError("CryptoEngineV1: engine is unavailable");
    const encryptedBase64 = CryptoJS.AES.encrypt(message, this.key, { mode: CryptoJS.mode.ECB }).toString();
    return CryptoJS.enc.Base64.parse(encryptedBase64).toString(CryptoJS.enc.Hex);
  }
}
